import api from './api';

async function deleteVacancyAPI(id: string) {
  const response = await api.delete(`/admin_vacancy/${id}/`);
  return response?.data;
}

export default deleteVacancyAPI;
